import {CONFIG_DATE_FORMAT} from '../../utils/formatter'
import moment from 'moment/moment'

export const VETTORI_LOAD_ALL = 'VETTORI_ALL_ITEMS'
export const HOTELS_LOAD_ALL = 'HOTELS_ALL_ITEMS'
export const SERVIZI_LOAD_ALL = 'SERVIZI_ALL_ITEMS'
export const TOURS_LOAD_ALL = 'TOURS_ALL_ITEMS'
export const EXPERIENCES_LOAD_ALL = 'EXPERIENCES_ALL_ITEMS'

const state = {
  vettori: {
    maxDiffPerc: 10,
    voloGiornoSuccessivo: null,
    list: []
  },
  hotels: {
    maxDiffPerc: 10,
    list: []
  },
  servizi: {
    list: []
  },
  tours: {
    list: []
  },
  experiences: {
    list: [],
    services: []
  }
}

const getters = {
  isGiornoSuccessivoObbligatorio: state => {
    return state.vettori.voloGiornoSuccessivo === 'Obbligatorio'
  },
  getVettori: state => {
    return {...state.vettori, list: state.vettori.list ? [...state.vettori.list] : []}
  },
  getHotels: state => {
    return {...state.hotels, periods: state.hotels.periods ? [...state.hotels.periods] : []}
  },
  hasHotels: state => {
    return state.hotels.list && state.hotels.list.length > 0
  },
  getServiziCodes: state => {
    // estrae tutti servizi disponibili in configurazione
    let servizi = state.servizi.list.map(function (item) {
      return {code: item.codice, trasferimento: item.isTrasferimento > 0}
    })

    // estrae i servizi presenti nelle experience
    let list = []
    state.experiences.list.forEach(experience => {
      experience.days.forEach(day => {
        if (day.list) {
          let results = day.list.map((item) => {
            return {code: item.codiceServizio, trasferimento: item.isTrasferimento === true}
          })
          list = list.concat(results)
        }
      })
    })
    servizi = servizi.concat(list)

    // estrae tutti i trasferimenti obbligatori presenti nei hotels
    list = []
    state.hotels.list.filter(item => item.isTrasferimentoObbligatorio).forEach(hotel => {
      list.push({code: hotel.codiceAndata, trasferimento: true})
      if (hotel.codiceAndata !== hotel.codiceRitorno) {
        list.push({code: hotel.codiceRitorno, trasferimento: true})
      }
    })
    servizi = servizi.concat(list)

    // estrae i servizi presenti nei vettori
    if (state.vettori && state.vettori.codiceHotelAlternativo) {
      servizi.push({code: state.vettori.codiceHotelAlternativo, trasferimento: false})
    }

    // elimina i record doppi
    servizi = servizi.filter((item, index) => servizi.indexOf(item) === index)
    servizi = servizi.concat(list.filter(item => {
      return !servizi.some(item2 => item2.code === item.code)
    }))
    let unique = []
    servizi.map(item => unique.filter(item2 => item2.code === item.code).length > 0 ? null : unique.push(item))

    // normalize
    servizi = unique.map(item => ({...item, code: item.code.trim()}))
    return servizi
  },
  getServizi: state => {
    return {...state.servizi, list: state.servizi.list ? [...state.servizi.list] : []}
  },
  getServiziList: state => {
    return state.servizi.list.filter(function (item) {
      return item.isTrasferimento === 0
    })
  },
  getTrasferimenti: state => {
    return state.servizi.list.filter(function (item) {
      return item.isTrasferimento > 0
    })
  },
  getAllTrasferimentiCodes: state => {
    const listTrasferimentiConfigs = state.servizi.list.filter((item) => item.isTrasferimento > 0).map(item => item.codice.trim())
    const listTrasferimentiHotels = []
    state.hotels.list.filter(item => item.isTrasferimentoObbligatorio).forEach(hotel => {
      const codiceAndata = hotel.codiceAndata.trim()
      const codiceRitorno = hotel.codiceRitorno.trim()
      listTrasferimentiHotels.push(codiceAndata)
      if (codiceAndata !== codiceRitorno) {
        listTrasferimentiHotels.push(codiceRitorno)
      }
    })
    return [...new Set(listTrasferimentiConfigs), ...new Set(listTrasferimentiHotels)]
  },
  getToursCodes: state => {
    let list = state.tours.list.map(function (item) {
      return item.codice
    })
    // add all experiences mini tours
    state.experiences.list.forEach(experience => {
      experience.days.forEach(day => {
        if (day.list) {
          if (day.isTourAbilitato && !list.some(item2 => item2 === 'mini_' + day.codiceTour)) {
            list.push('mini_' + day.codiceTour)
          }
        }
      })
    })
    return list
  },
  hasTours: state => {
    return state.tours.list && state.tours.list.length > 0
  },
  getTours: state => {
    const list = state.tours.list.map(function (item) {
      return {
        ...item,
        datesOffertaSpeciale: item.datesOffertaSpeciale ? [...item.datesOffertaSpeciale] : [],
        datesPartenzaGarantita: item.datesPartenzaGarantita ? [...item.datesPartenzaGarantita] : []
      }
    })
    return {list: list}
  },
  getToursOfferteSpeciali: state => {
    const list = state.tours.list.map(function (item) {
      return {
        ...item,
        datesOffertaSpeciale: item.datesOffertaSpeciale ? [...item.datesOffertaSpeciale] : [],
        datesPartenzaGarantita: item.datesPartenzaGarantita ? [...item.datesPartenzaGarantita] : []
      }
    })
    const listFiltered = list.filter(item => {
      return item.datesOffertaSpeciale.some(item => {
        const now = moment()
        const date = moment(item, CONFIG_DATE_FORMAT)
        if (date.isAfter(now)) return true
      })
    })
    return {list: listFiltered}
  },
  hasExperiences: state => {
    return state.experiences.list && state.experiences.list.length > 0
  },
  getExperiences: state => {
    return state.experiences.list.filter(function (item) {
      return item.isDisabilitato === false
    }).map(function (item) {
      return {
        ...item,
        days: item.days ? [...item.days] : [],
        datesRangeStagionalita: item.datesRangeStagionalita ? [...item.datesRangeStagionalita] : []}
    })
  }
}

const mutations = {
  [VETTORI_LOAD_ALL] (state, payload) {
    state.vettori = {...payload, list: [...payload.list]}
  },
  [HOTELS_LOAD_ALL] (state, payload) {
    state.hotels = {...payload, list: [...payload.list]}
  },
  [SERVIZI_LOAD_ALL] (state, payload) {
    state.servizi = {...payload, list: [...payload.list]}
  },
  [TOURS_LOAD_ALL] (state, payload) {
    state.tours = {...payload, list: [...payload.list]}
  },
  [EXPERIENCES_LOAD_ALL] (state, payload) {
    state.experiences = {...payload, list: [...payload.list]}
  }
}

const actions = {
  loadAllVettori ({ commit, state }, item) {
    commit(VETTORI_LOAD_ALL, item)
  },
  loadAllHotels ({ commit, state }, obj) {
    commit(HOTELS_LOAD_ALL, excludeDisabled(obj))
  },
  loadAllServizi ({ commit, state }, obj) {
    commit(SERVIZI_LOAD_ALL, excludeDisabled(obj))
  },
  loadAllTours ({ commit, state }, obj) {
    commit(TOURS_LOAD_ALL, excludeDisabled(obj))
  },
  loadAllExperiences ({ commit, state }, obj) {
    commit(EXPERIENCES_LOAD_ALL, excludeDisabled(obj))
  }
}

const excludeDisabled = (obj) => {
  obj.list = obj.list.filter(function (item) {
    return !item.isDisabilitato
  })
  return obj
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/front/store/modules/config.js